/** *******************************************************************************************************************
 * Copyright (c) 2020 - Fundação CERTI
 * All rights reserved.
 ******************************************************************************************************************* */
import React from 'react';

export default {
  existingEmail: (email) => ({
    title: 'Use outro endereço de email',
    content: (
      <p>
        O email
        {' '}
        <b>{email}</b>
        {' '}
        já está registrado e não pode ser usado para outro usuário.
      </p>
    ),
  }),
};
